import React from "react";
import { useSelector } from "react-redux";

import * as ImageViewerModule from "@redux/modules/value/imageViewer/imageViewer.module";
import * as ImageViewerSelectors from "@redux/modules/value/imageViewer/imageViewer.selectors";
import { useThunkDispatch } from "@redux/dispatcher";

import { ClientOnlyComponent } from "@components/Utils/clientOnly.component";

import { ImageViewerFullWidth } from "./imageViewerFullWidth.component";

export type ImageViewerFullWidthContainerProps = {
    images: any[];
    videos: any[];
    defaultVideoThumbnailPath?: string;
};

const ImageViewerFullWidthContainer = ({
    images,
    videos,
    defaultVideoThumbnailPath,
}: ImageViewerFullWidthContainerProps) => {
    const activeIndex = useSelector(ImageViewerSelectors.getActiveIndex);
    const dispatch = useThunkDispatch();
    const setActiveIndex = (index: number) => {
        dispatch(ImageViewerModule.update({ activeIndex: index }));
    };

    return (
        <ClientOnlyComponent>
            <ImageViewerFullWidth
                activeIndex={activeIndex}
                setActiveIndex={setActiveIndex}
                images={images || []}
                videos={videos || []}
                defaultVideoThumbnailPath={defaultVideoThumbnailPath}
            />
        </ClientOnlyComponent>
    );
};

export { ImageViewerFullWidthContainer };
